module.exports = __webpack_public_path__ + "static/media/rocket.6a584106.gif";